/** @prettier */

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {PrimaryButton} from '../../component/BasicButton';

/**
 * アカウント削除API失敗時のエラーダイアログ
 *
 *  アカウント削除時のエラーで特殊なエラーメッセージを表示するため新規でコンポーネントを作成
 * @param props props
 * - deleteAccountErrorOpen アカウント削除失敗ダイアログ開閉
 * - setDeleteAccountErrorOpen アカウント削除失敗ダイアログ開閉設定
 * - id ダイアログのID
 * - errorCode エラーコード
 * - errorParam パラメータ
 * @returns JSX
 */
const APIErrorMessage = (props: {
  deleteAccountErrorOpen: boolean;
  setDeleteAccountErrorOpen: React.Dispatch<React.SetStateAction<boolean>>;
  id?: string;
  errorCode: string;
  errorParam: string;
}) => {
  const trans = useTranslation().t; //翻訳関数

  /**
   * アカウント削除ダイアログを閉じる
   */
  const handleClose = () => {
    props.setDeleteAccountErrorOpen(false);
  };

  /**
   * エラーメッセージ選択関数
   * @param errorCode エラーコード
   * @param errorParam パラメータ
   * @return エラーメッセージ
   */
  const selectDialogText = (errorCode: string, errorParam: string) => {
    switch (errorCode) {
      case 'USER_DELETE_FORBIDDEN':
        return trans(
          'DeleteAccountAPIErrorMessage.errDialog.msg.forbiddenDelete',
          {name: errorParam}
        );
      case 'USER_DELETE_FORBIDDEN_OF_PAYING_USER':
        return trans(
          'DeleteAccountAPIErrorMessage.errDialog.msg.forbiddenDeleteOfPayingUser',
          {name: errorParam}
        );
      default:
        return trans(
          'DeleteAccountAPIErrorMessage.errDialog.msg.processingFailure'
        );
    }
  };
  return (
    <Dialog
      open={props.deleteAccountErrorOpen}
      onClose={handleClose}
      aria-labelledby="form-dialog-title">
      <DialogTitle
        id="form-dialog-title"
        className="accountSetting__dialog__title--error">
        {trans('DeleteAccountAPIErrorMessage.errDialog.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText className="accountSetting__dialog__content__text">
          {selectDialogText(props.errorCode, props.errorParam)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          onClick={handleClose}
          buttonText={trans(
            'DeleteAccountAPIErrorMessage.errDialog.buttonTxt.ok'
          )}
          id={props.id}
        />
      </DialogActions>
    </Dialog>
  );
};
export default APIErrorMessage;
